module.exports = __webpack_public_path__ + "img/ico-common-19.90e0df80.png";